<template lang="pug">
    div.individual-chart(:class="wrapperClass")
        sectionHeader(:title="name")
        v-chart(:option="chartDataAllocationCount" autoresize :class="className")
</template>

<script>
import SectionHeader from '@/components/common/SectionHeader'

export default {
    name: 'AllocationLinearGraph',

    components: {
        SectionHeader
    },

    props: {
        name: { type: String, required: true },
        allocationMetrics: { type: Object, required: true },
        hasAccountAccessToKibanaStats: { type: Boolean, required: false },
        className: { type: String, required: false, default: '' }
    },

    computed: {
        wrapperClass() {
            return this.className + '-wrapper'
        },
        chartDataAllocationCount() {
            const hasAccountAccessToKibanaStats = this.hasAccountAccessToKibanaStats
            return {
                legend: {
                    left: 'center',
                    top: '0',
                    textStyle: {
                        fontSize: 14
                    },
                    data: hasAccountAccessToKibanaStats ? ['Allocation', 'Affectation'] : ['Allocation']
                },
                xAxis: {
                    axisLine: {
                        lineStyle: {
                            color: '#A4A4A4'
                        }
                    },
                    axisTick: {
                        lineStyle: {
                            color: '#A4A4A4'
                        }
                    },

                    nameTextStyle: {
                        color: '#A4A4A4'
                    },
                    axisLabel: {
                        rotate: 25
                    },
                    nameLocation: 'center',
                    nameGap: 35,
                    type: 'category',
                    boundaryGap: false,
                    data: Object.keys(this.allocationMetrics.allocationByDate),
                    splitLine: {
                        show: false
                    }
                },
                grid: {
                    left: '7%',
                    bottom: '25%',
                    show: false
                },
                yAxis: [
                    {
                        type: 'value',
                        name: 'Allocation',
                        axisLine: {
                            lineStyle: {
                                color: '#A4A4A4'
                            }
                        },
                        axisTick: {
                            lineStyle: {
                                color: '#A4A4A4'
                            }
                        },
                        nameTextStyle: {
                            color: '#A4A4A4',
                            fontWeight: 'bold'
                        },
                        splitLine: {
                            show: true
                        },
                        nameGap: 15
                    },
                    ...this.kibanaYAxis
                ],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        label: {
                            show: true
                        }
                    }
                },
                series: [
                    {
                        type: 'line',
                        name: 'Allocation',
                        symbolSize: 5,
                        data: Object.values(this.allocationMetrics.allocationByDate),
                        sampling: 'average',
                        smooth: true,
                        areaStyle: {},
                        lineStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: '#1811f1' // color at 0% position
                                    },
                                    {
                                        offset: 1,
                                        color: '#11aef1' // color at 100% position
                                    }
                                ],
                                global: false // false by default
                            },
                            width: 3
                        }
                    },
                    ...this.kibanaSeries
                ]
            }
        },
        kibanaSeries() {
            if (!this.hasAccountAccessToKibanaStats) return []
            return [
                {
                    type: 'line',
                    name: 'Affectation',
                    yAxisIndex: 1,
                    symbolSize: 5,
                    data: Object.values(this.allocationMetrics.kibanaAllocation),
                    sampling: 'average',
                    smooth: true,
                    itemStyle: {
                        color: '#E6CF01',
                        width: 3
                    }
                }
            ]
        },
        kibanaYAxis() {
            if (!this.hasAccountAccessToKibanaStats) return []

            return [
                {
                    type: 'value',
                    name: 'Affectation',
                    splitLine: {
                        show: false
                    },
                    showGrid: false,
                    axisLine: {
                        show: false
                    },
                    nameTextStyle: {
                        color: '#A4A4A4',
                        fontWeight: 'bold'
                    },
                    nameGap: 15
                }
            ]
        }
    }
}
</script>
